import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { ITafAdaptationUploadResponse } from './types';
import { TAF_ADAPTATION_PROCESS_KEY } from './useGetTafAdaptationStatus';

interface IUploadPayload {
  registrationId: string;
  file: File;
}

const uploadTafAdaptationDocument = async ({
  registrationId,
  file,
}: IUploadPayload): Promise<ITafAdaptationUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await configApi.post<ITafAdaptationUploadResponse>(
    `attachment/registration/${registrationId}/step-upload/${TAF_ADAPTATION_PROCESS_KEY}/upload/`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const useUploadTafAdaptationDocument = (registrationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadTafAdaptationDocument({ registrationId, file }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taf_adaptation_status', registrationId] });
    },
  });
};
